<template>
	<div class="main">
		<div class="search"><input type="text" placeholder="请输入搜索内容" v-model="searchWord" @keydown.enter="getAgainSearchList"><div class="search-btn" @click='getAgainSearchList'>在结果中检索</div></div>
		<div class="main-item">
			
			<div class="title"><div>搜索“{{$route.query.search}} <span v-if=''></span>	”的牛人信息</div></div>
			<div v-if='resultList.total'>
				<div class="content">
					<div class="content-item" v-for="(item,index) in resultList.data"  >
						<div class="guanzhu">关注</div>
						<div class="personPic" @click="goto(`/geniusClub/geniusInfo?id=${item.id}`)">
							<img :src='getImgSrc(item.avatar)' alt="">
						</div>
						<div style="width: 100%;text-align: center;">
							<p>{{item.nickname}}</p>
						<p>{{item.school}}</p>
						<p>{{item.qualification}}</p>
						</div>
					</div>		
				</div>
				<div style="display: flex;justify-content: center;">
					<el-pagination
					  background
					   @current-change='currentChange'
					  :page-size="resultList.per_page"
					  layout="prev, pager, next"
					  :total="resultList.total">
					</el-pagination>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="150"></el-empty>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		props: {
			keyWord: {
				type: String
			}
		},
		data() {
			return{
				searchWord:'',
				resultList:[],
				userIds:[],
				flag:false,
				searchPage:1
			}
		},
		
		watch:{
			keyWord:{
				handler(newValue,oldValue){    
					// this.searchWord = newValue
					// console.log(newValue,oldValue);
					if(newValue){
						this.$route.query.search = newValue
					}
					this.getSearchList()
				},
				immediate: true,
			},
		},
		methods:{
			goto(url){
				this.$router.push(url)
			},
			currentChange(e){
				this.searchPage = e
				if(this.flag){
					this.getAgainSearchList()
				}else{
					this.getSearchList()
				}
			},
			// searchGeniusHandler
			async getSearchList(){
					const result = await this.$api.searchGeniusHandler({page:this.searchPage,keywords:this.$route.query.search})
					this.resultList = result.data.lists
					this.userIds = result.data.user_ids.join(',')
					this.flag = false
					console.log(result);
			},
			async getAgainSearchList(){
				const result = await this.$api.searchGeniusAgainHandler({page:this.searchPage,keywords:this.searchWord,user_ids:this.userIds})
				this.resultList = result.data.lists
				this.flag = true
			}
			// searchGeniusAgainHandler
		}
	}
</script>
<style>
	.el-pager li:not(.disabled).active{
		background: #0052d9 !important;
	}
</style>
<style scoped lang="less">
	.search{
		display: flex;
		justify-content: center;
		margin-bottom: 30px;
		.search-btn{
			padding: 0 15px;
			cursor: pointer;
			height: 50px;
			background: #0052D9;
			color: white;
			line-height: 50px;
			text-align: center;
			font-size: 18px;
			font-weight: bold;
			box-shadow: 0px 2px 11px 0px rgba(0,0,0,0.3);
		}
		input{
			font-size: 18px;
			padding: 0 10px;
			width: 600px;
			height: 50px;
			background: #FFFFFF;
			box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.3);
		}
	}
	.main{
		.main-item{
			.bottom-btn{
				display: flex;
				justify-content: flex-end;
				&>div{
					width: 172px;
					height: 47px;
					color: #0052D9;
					line-height: 47px;
					margin-right: 15px;
					text-align: center;
					cursor: pointer;
					border: 1px solid #0052D9;
				}
			}
			.content{
				display: flex;
				flex-wrap: wrap;
				.content-item{
					margin-bottom: 30px;
					position: relative;
					box-sizing: border-box;
					padding-top: 20px;
					display: flex;
					justify-content: center;
					flex-wrap: wrap;
					background: #F6F6F6;
					margin-left: 20px;
					&:first-child{
						margin-left: 0px;
					}
					.guanzhu{
						width: 48px;
						height: 38px;
						background: #0052D9;
						position: absolute;
						color: white;
						line-height: 38px;
						cursor: pointer;
						text-align: center;
						left: 0;
						top:0;
					}
					.personPic{
						cursor: pointer;
						width: 122px;
						height: 122px;
						background: #FFFFFF;
						border-radius: 50%;
						overflow: hidden;
						img{
							width: 100%;
							height: 100%;
						}
					}
					p{
						margin-bottom:8px;
						width: 100%;
						padding: 0 20px;
						box-sizing: border-box;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}
					width: 258px;
					height: 260px;
				transition: all 0.5s;
				}
				.content-item:hover{
					transform: scale(1.05);
					box-shadow: 0 3px 6px #7a7a7a;
				}
				padding: 30px 15px;
				box-sizing: border-box;
			}
			.title{
				background: #E5EDFB;
				&>div{
					font-size: 20px;
					color: white;
					line-height: 48px;
					font-weight: bold;
					display: inline-block;
					padding:0 20px;
					height: 48px;
					background: #0052D9;
					border-radius: 0px 24px 24px 0px;
				}
			}
			padding-bottom: 30px;
			box-sizing: border-box;
			background: white;
		}
		padding: 20px 0;
	}
</style>